// /plan — where Stripe returns someone who backed out of Checkout
// (STRIPE_CHECKOUT_CANCEL_URL). Abandoning payment must read as a non-event:
// the trial is card-free, nothing was charged, nothing was lost. Reassure,
// offer the retry, and hand them straight back to the app download.
import { useEffect } from 'react';
import { loadAnswers, loadClaimLink } from '../lib/session';
import { track } from '../lib/analytics';
import { GetTheApp } from '../screens/GetTheApp';

export function PlanApp() {
  useEffect(() => {
    document.title = 'Your plan · Expy Health';
    track('checkout_abandoned');
  }, []);

  return (
    <>
      <div
        role="status"
        style={{
          background: 'var(--teal-tint)',
          color: 'var(--teal-deep)',
          fontSize: 14,
          fontWeight: 700,
          textAlign: 'center',
          padding: '12px 16px',
          lineHeight: 1.5,
        }}
      >
        No charge was made. Your free trial is still active. You can set up your subscription any time.
      </div>
      <GetTheApp answers={loadAnswers()} claimLink={loadClaimLink()} offerSubscription />
    </>
  );
}
